
<div class="flex flex-row w-full">
  <div class="flex-grow">
    {{ color.name }}

    <div v-if="hasTextColors" class="mt-2">
      <div v-for="(color, idx) in color.colors" :key="idx" :style="`background-color: rgba(${color},1)`"
        @click="changeColor(color)"
        class="w-2 h-2 p-4 rounded float-left mr-2 mb-2 border-2  hover:border-brandhelfer-green cursor-pointer"
        :class="selectedColor == color
          ? 'border-brandhelfer-green cursor-default'
          : 'border-gray-200'
          "></div>

      <span v-if="hasPicker" class="float-left mr-2 mb-2" :title="pickerTooltip">
        <button type="button" :disabled="!pickerEnabled" @click="$emit('pickerRequested', color)"
          class="w-9 h-9 p-0 rounded border-2 border-gray-200 text-gray-700 flex items-center justify-center focus:outline-none"
          :class="pickerEnabled
            ? 'hover:text-brandhelfer-green hover:border-brandhelfer-green cursor-pointer'
            : 'opacity-40 cursor-not-allowed'"
          :style="pickerButtonStyle"
          aria-label="Farbe aus Hintergrund wählen">
          <i class="fa fa-eyedropper text-xs opacity-80" aria-hidden="true"></i>
        </button>
      </span>
    </div>
  </div>
  <div class="w-1/5">
    <toggle :idx="color.id" :enabled="color.enabled" @toggled="statusToggled"></toggle>
  </div>
</div>
